import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import SEO from "../components/SEO";
import { useApp } from "../context/AppContext";
import { formatApiErrorDetail } from "../lib/api";

export default function Login() {
  const { login, user } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <SEO title="Connexion atelier" path="/login" noindex />
      <div className="hidden flex-col justify-between bg-ink p-12 text-cream lg:flex">
        <Logo className="[&_span]:text-cream" />
        <div>
          <h1 className="font-serif text-6xl font-light leading-tight tracking-tight">Espace atelier.</h1>
          <p className="mt-4 max-w-sm text-cream/70">Gérez votre catalogue, vos réductions et suivez vos commandes.</p>
        </div>
        <p className="text-xs uppercase tracking-widest text-cream/50">o-crea · Suisse</p>
      </div>
      <div className="flex items-center justify-center px-5 py-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden"><Logo /></div>
          <h2 className="mt-8 font-serif text-3xl font-medium text-ink lg:mt-0">Connexion</h2>
          <p className="mt-2 text-sm text-ink2">Réservé à l'administration.</p>
          <label className="mt-8 block text-xs uppercase tracking-widest text-ink3">E-mail</label>
          <input
            value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
            data-testid="login-email"
            className="mt-2 w-full border border-line bg-cream px-4 py-3 text-sm outline-none focus:border-ink"
          />
          <label className="mt-5 block text-xs uppercase tracking-widest text-ink3">Mot de passe</label>
          <input
            value={password} onChange={(e) => setPassword(e.target.value)} type="password" required
            data-testid="login-password"
            className="mt-2 w-full border border-line bg-cream px-4 py-3 text-sm outline-none focus:border-ink"
          />
          <button
            type="submit" disabled={loading} data-testid="login-submit"
            className="mt-8 w-full bg-ink py-4 text-sm uppercase tracking-widest text-cream transition-colors hover:bg-terra disabled:opacity-50"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
